import React, { useState } from "react";
import { LifeBuoy } from "lucide-react";
import RaiseTicketModal from "@/pages/tickets/RaiseTicketModal";
import { toast } from "sonner";

/** Standalone "Raise Ticket" button. Mounted globally by DashboardLayout
 *  in a centered strip above every page's main content — see the strip
 *  in DashboardLayout.jsx which also handles hiding it on `/tickets`. */
export default function RaiseTicketFAB() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="h-10 px-3 rounded-full border border-[#262626] bg-[#0a0a0a] text-gray-300 hover:text-black hover:bg-[#d4af37] hover:border-[#d4af37] transition-colors flex items-center gap-1.5 text-xs font-mono uppercase tracking-widest"
        data-testid="raise-ticket-fab"
        title="Raise an internal ticket"
      >
        <LifeBuoy className="w-4 h-4" strokeWidth={1.5}/>
        <span className="hidden sm:inline">Raise Ticket</span>
      </button>
      {open && (
        <RaiseTicketModal
          onClose={() => setOpen(false)}
          onCreated={() => { setOpen(false); toast.success("Ticket raised"); }}
        />
      )}
    </>
  );
}
